"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
class AbstractPaginatedListStore {
    constructor() {
        this._loading = false;
        this._page = 0;
        this._items = [];
        this._error = null;
        this._isHaveNextPage = false;
        this.isHaveNextPage = () => this._isHaveNextPage;
        this.fetchPage = (page) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (page < 0) {
                return;
            }
            if (this._loading) {
                throw new Error("Cannot fetch again. The last fetch still loading.");
            }
            mobx_1.runInAction(() => (this._loading = true));
            try {
                const newItems = yield this.getDataItemsPerPage(page);
                mobx_1.runInAction(() => {
                    this._isHaveNextPage = newItems.length === 20;
                    this._items = newItems;
                    this._page = page;
                });
            }
            catch (e) {
                mobx_1.runInAction(() => (this._error = e.message || "error"));
                throw e;
            }
            finally {
                mobx_1.runInAction(() => (this._loading = false));
            }
        });
        this.refresh = () => {
            this.fetchPage(this.page);
        };
        this.clear = () => {
            mobx_1.runInAction(() => (this._items = []));
        };
        this.applyFilter = (predicate) => {
            mobx_1.runInAction(() => (this._items = this._items.filter(predicate)));
        };
        this.nextPage = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield this.fetchPage(this._page + 1); });
        this.previousPage = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield this.fetchPage(this._page - 1); });
        this.setLoading = (isLoading) => {
            mobx_1.runInAction(() => (this._loading = isLoading));
            return null;
        };
        mobx_1.makeObservable(this, {
            _loading: mobx_1.observable,
            _page: mobx_1.observable,
            _items: mobx_1.observable,
            _error: mobx_1.observable,
            _isHaveNextPage: mobx_1.observable,
        });
    }
    get page() {
        return this._page;
    }
    getPagination() {
        return {
            page: this.page,
            onNextClick: () => this.nextPage(),
            onPreviousClick: () => this.previousPage(),
        };
    }
}
exports.default = AbstractPaginatedListStore;
